import styled from 'styled-components'

type FormSectionProps = {
  $fullWidth?:boolean;
}

export const Container = styled.div`
  width: 100%;
  max-width: 1240px;
  padding: 20px 30px 50px 20px;
  box-sizing: border-box;

  @media (max-width: 640px) {
    padding: 16px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 24px;
`

export const PageBody = styled.div`
  width: 100%;
`

export const Form = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 20px;

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const FormSection = styled.section<FormSectionProps>`
  grid-column: ${({$fullWidth}) => $fullWidth ? '1 / -1' : 'auto'};
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
  padding: 22px;
  box-sizing: border-box;
  background: ${({theme}) => theme.palette[10]};
  border: 1px solid ${({theme}) => theme.palette[300]};
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(30, 30, 30, 0.05);

  @media (max-width: 640px) {
    grid-column: 1;
    padding: 18px;
  }
`

export const SectionHeader = styled.div`
  padding-bottom: 14px;
  border-bottom: 1px solid ${({theme}) => theme.palette[300]};
`

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 18px;

  @media (max-width: 640px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const ThreeColumnGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: start;
  gap: 18px;

  @media (max-width: 760px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const WideField = styled.div`
  grid-column: 1 / -1;
  min-width: 0;
`

export const Checkboxes = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 28px;
  padding-top: 2px;
`

export const ButtonsWrapper = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 4px;

  @media (max-width: 640px) {
    flex-direction: column;

    & > * {
      width: 100%;
      justify-content: center;
    }
  }
`
